{
  "common": {
    "login": "Connexion",
    "error": "Une erreur s'est produite",
    "goHome": "Retour à l'accueil",
    "loading": "Chargement..."
  },
  "pages": {
    "login": {
      "pageTitle": "Connexion"
    },
    "notFound": {
      "message": "Page non trouvée",
      "title": "Oups"
    },
    "dashboard": {
      "title": "Éléments Widget",
      "createButton": "Nouveau Widget",
      "noData": "Aucun élément trouvé",
      "columns": {
        "name": "Nom",
        "description": "Description",
        "status": "Statut",
        "createdOn": "Créé le"
      },
      "status": {
        "active": "Actif",
        "inactive": "Inactif"
      },
      "createTitle": "Créer un Widget",
      "form": {
        "name": "Nom",
        "description": "Description",
        "isActive": "Actif",
        "nameRequired": "Le nom est requis."
      }
    }
  }
}
